import React from 'react';
import '../template-file-css/document-file-template.css'; 


export const ACTS_MSTCaseSummary = ({
    itemsRef,
    showErrorFor, 
}) => {

    return (
        <form id='ACTS_MSTCaseSummary' className='file-pdf-document'>
            <div className='file-template'>  
             
					<h2>
						Amethyst Consulting & Treatment Solutions, PLLC
						MULTISYSTEMIC THERAPY PROGRAM
					</h2>
					<h3>
						Case Plan
					</h3>
					<table>
						<tr>
							<td className='w-250'>
								<span className='eleHeader'>Family:</span>
								<input type='text' id="txtFamily" name="txtFamily" className='add-only' />
							</td>
							<td className='w-250'>
								<span className='eleHeader'>Therapist:</span>
								<input type='text' id="txtTherapist" name="txtTherapist" className='add-only' />
							</td>
							<td className='w-250'>
								<span className='eleHeader'>Date:</span>
								<input type='date' id="txtDate" name="txtDate" className='add-only' />
							</td>
						</tr>
						<tr>
							<td className='w-250'>
								<span className='eleHeader'>Child`s Age:</span>
								<input type='text' id="txtChildAge" name="txtChildAge" className='add-only' />
							</td>
							<td className='w-250'>
								<span className='eleHeader'>Start Date:</span>
								<input type='date' id="txtStartDate" name="txtStartDate" className='add-only' />
							</td>
							<td className='w-250'>
								<span className='eleHeader'>End Date:</span>
								<input type='date' id="txtEndDate" name="txtEndDate" className='add-only' />
							</td>
						</tr>
						<tr>
							<td className='w-250'>
								<span className='eleHeader'>Probation Officer:</span>
								<input type='text' id="txtProbationOfficer" name="txtProbationOfficer" className='add-only' />
							</td>
							<td className='w-250'>
								<span className='eleHeader'>CFT Date:</span>
								<input type='date' id="txtCftDate" name="txtCftDate" className='add-only' />
							</td>
							<td className='w-250'>
								<span className='eleHeader'>Group Supervision/Consultation Date:</span>
								<input type='date' id="txtConsultDate" name="txtConsultDate" className='add-only' />
							</td>
						</tr>
					</table>
					<h4>
						CASE OVERVIEW:
					</h4>
					<p>
						<span className='eleHeader'>1. Overarching MST Goals:</span>
						<textarea id="txtOverarchGoal" name="txtOverarchGoal" className='add-only'></textarea>
					</p>
					<table>
						<tr>
							<td className='w-150'><span className='eleHeader'>Date Range</span></td>
							<td className='w-100'><span className='eleHeader'>OAG 1 (# Incidents)</span></td>
							<td className='w-100'><span className='eleHeader'>Info</span></td>
							<td className='w-100'><span className='eleHeader'>OAG 2 (# Incidents)</span></td>
							<td className='w-100'><span className='eleHeader'>Info</span></td>
							<td className='w-100'><span className='eleHeader'>OAG 3 (# Incidents)</span></td>
							<td className='w-100'><span className='eleHeader'>Info</span></td>
						</tr>
						<tr>
							<td className='w-150'>
								<input type='date' id="txtDateRange_1" name="txtDateRange_1" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtOag1_1" name="txtOag1_1" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtInfo1_1" name="txtInfo1_1" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtOag2_1" name="txtOag2_1" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtInfo2_1" name="txtInfo2_1" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtOag3_1" name="txtOag3_1" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtInfo3_1" name="txtInfo3_1" className='add-only' />
							</td>
						</tr>
						<tr>
							<td className='w-150'>
								<input type='date' id="txtDateRange_2" name="txtDateRange_2" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtOag1_2" name="txtOag1_2" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtInfo1_2" name="txtInfo1_2" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtOag2_2" name="txtOag2_2" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtInfo2_2" name="txtInfo2_2" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtOag3_2" name="txtOag3_2" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtInfo3_2" name="txtInfo3_2" className='add-only' />
							</td>
						</tr>
						<tr>
							<td className='w-150'>
								<input type='date' id="txtDateRange_3" name="txtDateRange_3" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtOag1_3" name="txtOag1_3" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtInfo1_3" name="txtInfo1_3" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtOag2_3" name="txtOag2_3" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtInfo2_3" name="txtInfo2_3" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtOag3_3" name="txtOag3_3" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtInfo3_3" name="txtInfo3_3" className='add-only' />
							</td>
						</tr>
						<tr>
							<td className='w-150'>
								<input type='date' id="txtDateRange_4" name="txtDateRange_4" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtOag1_4" name="txtOag1_4" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtInfo1_4" name="txtInfo1_4" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtOag2_4" name="txtOag2_4" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtInfo2_4" name="txtInfo2_4" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtOag3_4" name="txtOag3_4" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtInfo3_4" name="txtInfo3_4" className='add-only' />
							</td>
						</tr>
						<tr>
							<td className='w-150'>
								<input type='date' id="txtDateRange_5" name="txtDateRange_5" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtOag1_5" name="txtOag1_5" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtInfo1_5" name="txtInfo1_5" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtOag2_5" name="txtOag2_5" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtInfo2_5" name="txtInfo2_5" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtOag3_5" name="txtOag3_5" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtInfo3_5" name="txtInfo3_5" className='add-only' />
							</td>
						</tr>
					</table>
					<p>
						<span className='eleHeader'>
							UPDATED CASE INFORMATION:
						</span>
						<textarea id="txtUpdatedCase" name="txtUpdatedCase" className='add-only'></textarea>
					</p>					
					<table>
						<tr>
							<td className='w-300'><span className='eleHeader'>2. Contacts</span></td>
							<td className='w-150'><span className='eleHeader'>w/ Families</span></td>
							<td className='w-150'><span className='eleHeader'>w/ Agencies</span></td>
							<td className='w-150'><span className='eleHeader'>Total</span></td>
						</tr>
						<tr>
							<td className='w-300'><b># Face-to-Face Contacts</b></td>
							<td className='w-150'>
								<input type='text' id="txtFamilies_1" name="txtFamilies_1" className='add-only' />
							</td>
							<td className='w-150'>
								<input type='text' id="txtAgencies_1" name="txtAgencies_1" className='add-only' />
							</td>
							<td className='w-150'>
								<input type='text' id="txtTotal_1" name="txtTotal_1" className='add-only' />
							</td>
						</tr>
						<tr>
							<td className='w-300'><b># Phone Contacts</b></td>
							<td className='w-150'>
								<input type='text' id="txtFamilies_2" name="txtFamilies_2" className='add-only' />
							</td>
							<td className='w-150'>
								<input type='text' id="txtAgencies_2" name="txtAgencies_2" className='add-only' />
							</td>
							<td className='w-150'>
								<input type='text' id="txtTotal_2" name="txtTotal_2" className='add-only' />
							</td>
						</tr>
						<tr>
							<td className='w-300'><b># Cancelled Sessions</b></td>
							<td className='w-150'>
								<input type='text' id="txtFamilies_3" name="txtFamilies_3" className='add-only' />
							</td>
							<td className='w-150'>
								<input type='text' id="txtAgencies_3" name="txtAgencies_3" className='add-only' />
							</td>
							<td className='w-150'>
								<input type='text' id="txtTotal_3" name="txtTotal_3" className='add-only' />
							</td>
						</tr>
						<tr>
							<td className='w-300'><b>#  No Shows</b></td>
							<td className='w-150'>
								<input type='text' id="txtFamilies_4" name="txtFamilies_4" className='add-only' />
							</td>
							<td className='w-150'>
								<input type='text' id="txtAgencies_4" name="txtAgencies_4" className='add-only' />
							</td>
							<td className='w-150'>
								<input type='text' id="txtTotal_4" name="txtTotal_4" className='add-only' />
							</td>
						</tr>
					</table>
					<p>
						<span className='eleHeader'>
							3. Previous Intermediary Goals:
						</span>
						<span className='small'>
							(Cut and Paste the "New IG`s" table from the prior week here)
						</span>
						<textarea id="txtPreviousGoals" name="txtPreviousGoals" className='add-only'></textarea>
					</p>
					<p>
						<span className='eleHeader'>
							4. Barriers to Previous Intermediary Goals:
						</span>
						<textarea id="txtBarriersPrevious" name="txtBarriersPrevious" className='add-only'></textarea>
					</p>
					<p>
						<span className='eleHeader'>
							5. Advances in Treatment:
						</span>
						<textarea id="txtAdvancesTreat" name="txtAdvancesTreat" className='add-only'></textarea>
					</p>
					<p>
						<span className='eleHeader'>
							6.  Assessment of the "fit" between problems and their systemic context:
						</span>
						<span className='small'>
							(Include any working FITS/anchors for new IG`s here)
						</span>
						<textarea id="txtAssessProblem" name="txtAssessProblem" className='add-only'></textarea>
					</p>
					<h4>7. New Intermediary Goals:</h4>
					<table>
						<tr>
							<td className='w-150'><span className='eleHeader'>Goal/FIT-Driver</span></td>
							<td className='w-300'><span className='eleHeader'>Interventions/action steps</span></td>
							<td className='w-100'><span className='eleHeader'>M</span></td>
							<td className='w-100'><span className='eleHeader'>P</span></td>
							<td className='w-100'><span className='eleHeader'>N</span></td>
						</tr>
						<tr>
							<td className='w-150'>
								<input type='text' id="txtGoal_1" name="txtGoal_1" className='add-only' />
							</td>
							<td className='w-300'>
								<input type='text' id="txtInterventions_1" name="txtInterventions_1" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtM_1" name="txtM_1" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtP_1" name="txtP_1" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtN_1" name="txtN_1" className='add-only' />
							</td>
						</tr>
						<tr>
							<td className='w-150'>
								<input type='text' id="txtGoal_2" name="txtGoal_2" className='add-only' />
							</td>
							<td className='w-300'>
								<input type='text' id="txtInterventions_2" name="txtInterventions_2" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtM_2" name="txtM_2" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtP_2" name="txtP_2" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtN_2" name="txtN_2" className='add-only' />
							</td>
						</tr>
						<tr>
							<td className='w-150'>
								<input type='text' id="txtGoal_3" name="txtGoal_3" className='add-only' />
							</td>
							<td className='w-300'>
								<input type='text' id="txtInterventions_3" name="txtInterventions_3" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtM_3" name="txtM_3" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtP_3" name="txtP_3" className='add-only' />
							</td>
							<td className='w-100'>
								<input type='text' id="txtN_3" name="txtN_3" className='add-only' />
							</td>
						</tr>
					</table>
					<p>
						<span className='eleHeader'>
							Questions for supervision/consultation:
						</span>
						<textarea id="txtQuesConsult" name="txtQuesConsult" className='add-only'></textarea>
					</p>
					<p>
						<span className='eleHeader'>
							Supervision Feedback:
						</span>
						<textarea id="txtSupervisionFeed" name="txtSupervisionFeed" className='add-only'></textarea>
					</p>
					<p>
						<span className='eleHeader'>
							Consultation Feedback:
						</span>
						<textarea id="txtConsultFeed" name="txtConsultFeed" className='add-only'></textarea>
					</p>
					<table>
						<tr>
							<td className='signature w-500'>
								&nbsp;
							</td>
							<td className='signature w-250'>
								&nbsp;
							</td>
						</tr>
						<tr>
							<td className="small w-500">
								Supervisor Signature :
							</td>
							<td className="small w-250">
								Date:
							</td>
						</tr>
					</table>
					<table>
						<tr>
							<td className='signature w-500'>
								&nbsp;
							</td>
							<td className='signature w-250'>
								&nbsp;
							</td>
						</tr>
						<tr>
							<td className="small w-500">
								MST Therapist Signature:
							</td>
							<td className="small w-250">
								Date:
							</td>
						</tr>
					</table>
					

            
             



            </div>
        </form>

    )
}  
